import Tick from '@pqina/flip';
import '@pqina/flip/dist/flip.min.css';
import './clock.css';

const template = (transform) => `<div class="tick">
  <div data-repeat="true" data-layout="horizontal fit" data-transform="${transform}">
    <div class="tick-group">
      <div data-key="value" data-repeat="true" data-transform="pad(00) -> split -> delay">
        <span data-view="flip"></span>
      </div>
    <span data-key="label" data-view="text" class="tick-label"></span>
  </div>
</div>`;

class Ticker {
  constructor(startTime, container, format) {
    this.format = format;
    const element = document.createElement('div');
    this.element = element;
    element.innerHTML = template(`preset(${this.format.join(',')}) -> delay`);
    container.appendChild(element);
    Tick.DOM.create(element, {
      didInit: (tick) => this.start(tick, startTime)
    });
  }
  start(tick, startTime) {
    const locale = {
      YEAR_PLURAL: '年',
      YEAR_SINGULAR: '年',
      MONTH_PLURAL: '月',
      MONTH_SINGULAR: '月',
      WEEK_PLURAL: '週',
      WEEK_SINGULAR: '週',
      DAY_PLURAL: '天',
      DAY_SINGULAR: '天',
      HOUR_PLURAL: '時',
      HOUR_SINGULAR: '時',
      MINUTE_PLURAL: '分',
      MINUTE_SINGULAR: '分',
      SECOND_PLURAL: '秒',
      SECOND_SINGULAR: '秒',
      MILLISECOND_PLURAL: '毫秒',
      MILLISECOND_SINGULAR: '毫秒'
    }
    for (const [k, v] of Object.entries(locale)) {
      tick.setConstant(k, v);
    }
    const counter = Tick.count.up(startTime , { format: this.format });
    counter.onupdate = (value) => {
      tick.value = value;
    };
    this.counter = counter;
  }
  stop() {
    this.counter.timer.stop();
    Tick.DOM.destroy(this.element);
    this.counter = null;
    this.element = null;
  }
}

class YearTicker extends Ticker {
  constructor(startTime, container) {
    super(startTime, container, ['y','M','d','h','m','s']);
  }
}

class DayTicker extends Ticker {
  constructor(startTime, container) {
    super(startTime, container, ['d','h','m','s']);
  }
}

export class Clock {
  constructor(firstDay, container) {
    this.firstDay = firstDay;
    this.container = container;
    this.ticker = new YearTicker(firstDay, container);
  }
  switch() {
    this.ticker.stop();
    const TickerConstructor = this.ticker instanceof YearTicker ? DayTicker : YearTicker;
    this.ticker = new TickerConstructor(this.firstDay, this.container);
  }
}
